// extracted by mini-css-extract-plugin
export default {"tabsContainer":"styles_tabsContainer__fwAHN","tab":"styles_tab__jFe88","icon":"styles_icon__fL77L","active":"styles_active__rTTEN","content":"styles_content__Atsm5"};